module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABmJLR0QA/wD/AP+gvaeTAAABAUlEQVRIie2Uu5HCMBiEv6EID4+EkF5MCZdzEPMoAHpxFVxCQAAZPVwBmAAiE3gNHpDFLzAR7IxGsr3/riRLC5+CIRCVniO9qwUjIAN2Eo40zvTtZZQFdzfjyFP3EH1gCRwk6GqpOHGo+MIjWtXmITPPgCMwBloebguYiJthXMmfyGPrjICpapYWcipyM8CgqZq9hVzsaSicdQ1DYQ8YAAnwD6yeMK+cSRf3ifmV4bqizmyARBKJusy6rxqUsSLfpoR823p1rMAK809O1fsu2C066u+Oqctgo/4nwKDgbi3kmGtUTIG2h9sGZsCJgKiAPLjeFnYFYvJsKaKj1rj+4oIzZ3h4pv6ikZQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/socialIcons/igtv-24.png
// module id = 1285
// module chunks = 0